import { Task } from '@dieterApi/task/useTaskQuery';
import { ApplicationStatus, UserApplicationQuestionnaires } from '@dieterApi/user/useUserQuery';

// Determine application status based on questionnaires & ignored tasks
export function calculateApplicationStatus(app: UserApplicationQuestionnaires, tasks?: Task[]): ApplicationStatus {
  const task = tasks?.find((t) => t.applicationId === app.id);
  if (task?.isIgnored) return ApplicationStatus.COMPLETED;
  const questionnaires = app.questionnaires || [];
  if (!questionnaires.length) return ApplicationStatus.NOT_STARTED;
  const latest = [...questionnaires]
    .sort((a, b) => new Date(a.updatedAt || 0).getTime() - new Date(b.updatedAt || 0).getTime())
    .slice(-1)[0];
  if (!latest || latest.progress === 0) return ApplicationStatus.NOT_STARTED;
  if (latest.progress < 1) return ApplicationStatus.IN_PROGRESS;
  return ApplicationStatus.COMPLETED;
}

export interface WeightedProgressResult {
  weighted: number; // sum of weights
  total: number; // number of applications
  percent: number; // 0-100 rounded
}

// completed=1, in-progress=0.5, not-started=0
export function computeWeightedProgress(
  applications: UserApplicationQuestionnaires[] = [],
  tasks?: Task[]
): WeightedProgressResult {
  const total = applications.length;
  if (!total) return { weighted: 0, total: 0, percent: 0 };
  const weighted = applications.reduce((sum, app) => {
    const status = calculateApplicationStatus(app, tasks);
    if (status === ApplicationStatus.COMPLETED) return sum + 1;
    if (status === ApplicationStatus.IN_PROGRESS) return sum + 0.5;
    return sum;
  }, 0);
  return { weighted, total, percent: Math.round((weighted / total) * 100) };
}
